export default "__VITE_ASSET__6b6b8251__"